import PbAjax from "up-pbajax";
import publicpb from "@js/base/public.pb";
import RiskcontrolReport from "./RiskcontrolReport.pb";
import lang from "../../lang";
import global from "@js/base/global";

const HTTP = new PbAjax();

export default function (_params) {
  const { Request } = RiskcontrolReport.Riskcontrol.Event;

  let params = new Request(_params);
  let requestData = {
    service: "gridmap",
    api: "/report/td",
    header: {
      "Accept-Language": lang.type,
      userToken: global.getUser().userToken,
    },
  };

  //console.log('同盾上报：', _params);

  return new Promise((resolve, reject) => {
    HTTP.do(
      requestData,
      params,
      (res) => {
        let result = publicpb.Result.decode(res) || {};
        let { code, msg } = result;
        code ? resolve(result) : reject(msg);
      },
      () => {
        reject();
      },
      () => {
        reject();
      }
    );
  });
}



// WEBPACK FOOTER //
// ./js/component/TD/sendBlackbox.js